export default __webpack_public_path__ + "static/media/Logo-saoviet.c55ce76e.png";